const buildOgImageUrl = (meta: Meta | undefined): string | undefined => {
    if (!meta) return
    if (typeof meta.og_image === 'string') {
        return meta.og_image
    }
    return (meta.og_image ? meta.og_image['1200x630-t'] : undefined)?.url || undefined
}

export const usePageMeta = ({ meta, title, og_type, robots, description }: { meta?: Meta; title?: string; og_type?: string, robots?: string , description?: string}): void => {

    const config = useRuntimeConfig()
    const route = useRoute()

    const ogImageUrl: string | undefined = buildOgImageUrl(meta)

    useSeoMeta({
        title: meta?.meta_title || title || '',
        description: meta?.meta_description || description || '',
        keywords: meta?.meta_keywords,
        ogTitle: meta?.og_title || meta?.meta_title || title || '',
        ogDescription: meta?.og_description || meta?.meta_description || description || '',
        ogImage: ogImageUrl || '',
        ogUrl: meta?.canonical_url || `${config.public.publicPath}${route.fullPath}` || '',
    })

    useHead({
        meta: [
            {
                name: 'type',
                content: meta?.og_type || og_type || 'website',
            },
            {
                property: 'og:type',
                content: meta?.og_type || og_type || 'website',
            }
        ],
    })

    if(meta?.canonical_url) {
        useHead({
            link: [{ rel: 'canonical', href: meta.canonical_url }],
        })
    }

    if(config.public.NO_INDEX_OVERRIDE) {
        useHead({
            meta: [
                {
                    name: 'robots',
                    content: 'nofollow, noindex',
                },
            ],
        })
        return
    }

    if ((meta?.robot_follow && meta?.robot_index) || robots) {

        useHead({
            meta: [
                {
                    name: 'robots',
                    content: (meta?.robot_follow && meta.robot_index) ? `${meta?.robot_follow}, ${meta?.robot_index}` : robots,
                },
            ],
        })
    }
}
